import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalvarsService } from 'src/app/services/globalvars.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class EditUserComponent implements OnInit {

  public pageId = 0;

  username = '';
  password = '';
  name = '';

  constructor(
    private route: ActivatedRoute,
    private rest: RestService,
    private globalvar: GlobalvarsService,
    private router: Router
  ) { }


  ngOnInit(): void {

    this.route.params.subscribe(params => {
      this.pageId = params['id'];
    });

    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    this.rest.getUser(tmpToken.accessToken, this.pageId)
      .then(value => {
        let val: any = value;
        this.username = val[0].username
        this.password = val[0].password
        this.name = val[0].name
      })
      .catch(err => {
        this.globalvar.storeToken('');
        this.router.navigateByUrl('/logon');
      })

  }

  save() {
    if (this.password.length < 8 || !this.password) {
      return
    }

    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    let user = {
      username : this.username,
      password : this.password,
      name : this.name
    }

    this.rest.putUser(tmpToken.accessToken, user, this.pageId)
    .then(value => {
      this.router.navigateByUrl('/users');
    })
    .catch(err => {

      this.globalvar.storeToken('');
      this.router.navigateByUrl('/logon');
    })
  }

  delete() {
    let tmpToken: any
    this.globalvar.getToken.subscribe(retValue => tmpToken = retValue);

    this.rest.delUser(tmpToken.accessToken, this.pageId)
    .then(value => {
      this.router.navigateByUrl('/users');
    })
    .catch(err => {

      this.globalvar.storeToken('');
      this.router.navigateByUrl('/logon');
    })
  }

  cancel() {
    this.router.navigateByUrl('/users');
  }
}
